import { collapseDrawer, expandDrawer } from '../utils/animation.js';
import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';

const selectors = {
  button: '[data-accordion-drawer-button]',
  content: '[data-accordion-drawer-content]',
  header: '[data-accordion-drawer-header]',
};

class AccordionDrawer {
  /**
   * @param {Element} element
   */
  constructor(element) {
    this.element = element;

    this.button = this.element.querySelector(selectors.button);
    this.content = this.element.querySelector(selectors.content);
    this.header = this.element.querySelector(selectors.header);

    this.init();
  }

  init() {
    this.registerEventListeners();
  }

  registerEventListeners() {
    this.button.addEventListener('click', () => {
      this.toggle();
    });
  }

  toggle() {
    const expanded = this.button.getAttribute('aria-expanded');

    if (expanded === 'true') {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    collapseDrawer(this.content);

    this.button.setAttribute('aria-expanded', 'false');
    this.element.dataset.state = 'closed';
    this.content.dataset.state = 'closed';
    this.content.style.minHeight = '0px';
    this.content.style.height = '0px';
    this.element.classList.remove('mb-3');
  }

  open() {
    expandDrawer(this.content);
    this.content.classList.add('h-auto');
    this.button.setAttribute('aria-expanded', 'true');
    this.element.dataset.state = 'open';
    this.content.dataset.state = 'open';
    this.element.classList.add('mb-3');

    this.emitCloseAllEvent();
  }

  emitCloseAllEvent() {
    dispatchEvent(EVENT.ACCORDION.DRAWERCLOSED, this.element, {
      detail: {
        drawer: this,
      },
    });
  }
}

export default AccordionDrawer;
